import React from "react";

const CardComponent = (props) => {
  return (
    <div className="container-margin">
      <div className="new-investor-card-header">
        {props.title.toUpperCase()}
      </div>
      <div
        className={
          !props.style ? "new-investor-card" : "new-investor-card-active"
        }
      >
        {props.children}
      </div>
    </div>
  );
};
const SummaryCard = (props) => {
  return (
    <>
      <div className="container-margin">
        <div className="new-investor-summary-card-header">{props.title}</div>
        <div className="new-investor-summary-card">{props.children}</div>
      </div>
    </>
  );
};

export default CardComponent;
export { SummaryCard };
